import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Clock } from 'lucide-react';
import { COMPANY, NAV_LINKS, SERVICES } from '../lib/site';

export const Footer = () => {
    return (
        <footer data-testid="site-footer" className="bg-primary text-primary-foreground relative overflow-hidden">
            <div className="container-axion py-20 md:py-24">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
                    <div className="md:col-span-5">
                        <Link to="/" className="inline-block mb-6">
                            <img
                                src="/logo-watermark.png"
                                alt="Axion Cleaning Limited"
                                className="h-16 w-auto brightness-0 invert opacity-90"
                            />
                        </Link>
                        <p className="text-white/70 max-w-md leading-relaxed text-[15px]">
                            Considered cleaning for the homes, offices and short-lets of Bristol. Quietly thorough,
                            fully insured and rated 5★ by our clients.
                        </p>
                        <div className="mt-8 flex flex-col gap-3 text-sm text-white/80">
                            <a href={`mailto:${COMPANY.email}`} className="flex items-center gap-3 hover:text-white" data-testid="footer-email">
                                <Mail className="w-4 h-4 text-accent" /> {COMPANY.email}
                            </a>
                            <a href={`tel:${COMPANY.phone}`} className="flex items-center gap-3 hover:text-white" data-testid="footer-phone">
                                <Phone className="w-4 h-4 text-accent" /> {COMPANY.phoneDisplay}
                            </a>
                            <div className="flex items-center gap-3">
                                <MapPin className="w-4 h-4 text-accent" /> {COMPANY.region}
                            </div>
                            <div className="flex items-center gap-3">
                                <Clock className="w-4 h-4 text-accent" /> {COMPANY.hours}
                            </div>
                        </div>
                    </div>

                    <div className="md:col-span-3">
                        <div className="overline text-accent">Navigate</div>
                        <ul className="mt-5 flex flex-col gap-3 text-sm text-white/80">
                            {NAV_LINKS.map((l) => (
                                <li key={l.to}>
                                    <Link to={l.to} className="hover:text-white transition-colors">{l.label}</Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="md:col-span-4">
                        <div className="overline text-accent">Services</div>
                        <ul className="mt-5 grid grid-cols-1 gap-3 text-sm text-white/80">
                            {SERVICES.map((s) => (
                                <li key={s.slug}>
                                    <Link to="/services" className="hover:text-white transition-colors">{s.title}</Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>

                <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-xs text-white/50">
                    <span>© {new Date().getFullYear()} {COMPANY.legal}. All rights reserved.</span>
                    <span>Fully insured · Bristol-based · Trained teams</span>
                </div>
            </div>
        </footer>
    );
};
